import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { CircularProgress } from '@mui/material';
import theme from './theme';

import HomePage from './pages/HomePage';
import CheckinPage from './pages/CheckinPage2';
import DepositoSelectionPage from './pages/DepositoSelectionPage';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import BillingPanelPage from './pages/BillingPanelPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import { AuthProvider, useAuth } from './context/AuthProvider';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <AuthProvider>
          <AuthRoutes />
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
}

const AuthRoutes: React.FC = () => {
  const { loading, isAuthenticated } = useAuth();

  if (loading) return <CircularProgress />;

  return (
    <Routes>
      <Route path="/login" element={!isAuthenticated ? <LoginPage /> : <Navigate to="/" />} />

      <Route element={<ProtectedRoute />}>
        <Route path="/" element={<RedirectToDepositoOrHome />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/deposito-selection" element={<DepositoSelectionPage />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="/checkin" element={<CheckinPage />} />
        <Route path="/billing" element={<BillingPanelPage />} />
        <Route path="/register" element={<RegisterPage />} />
      </Route>

      <Route path="*" element={<Navigate to={isAuthenticated ? "/" : "/login"} />} />
    </Routes>
  );
};


export default App;

const RedirectToDepositoOrHome: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const selectedDeposito = localStorage.getItem('selectedDeposito');
    if (selectedDeposito) {
      navigate('/home');
    } else {
      navigate('/deposito-selection');
    }
  }, [navigate]);

  return null; // Este componente não renderiza nada, apenas redireciona
};

